import PropTypes from 'prop-types';
import React from 'react';
import { Modal } from 'react-bootstrap';

import HotelSearchPrefsForm from './HotelSearchPrefsForm';

class HotelSearchPrefsModal extends React.Component {
  render() {
    const groups = this.props.groups;

    const searchPrefs = groups.map(group => (
      <div key={group.id} className="group">
        <h4 className="spacing">{group.name}</h4>
        <HotelSearchPrefsForm
          id={group.id}
          prefs={group.hotel_prefs}
          brandList={this.props.brandList}
          savePreferences={this.props.savePreferences}
          onClose={this.props.onClose}
        />
      </div>
    ));
    return (
      <div>
        <Modal bsSize="large" show={this.props.show} onHide={this.props.onClose}>
          <Modal.Header closeButton>
            <Modal.Title>Hotel Search Preferences</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="bid-panel-big">
              <div className="group-info">
                <h4>Find the right hotel</h4>
                <p>You will be able to add or remove hotels from individual tour stops.</p>
                <p>
                  Hotel searches are centered on the venue location for each city. Select your
                  preferred hotel brands to improve your search.
                </p>

                {searchPrefs}
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer />
        </Modal>
      </div>
    );
  }
}

HotelSearchPrefsModal.propTypes = {
  groups: PropTypes.arrayOf(PropTypes.object).isRequired,
  brandList: PropTypes.arrayOf(PropTypes.object).isRequired,
  show: PropTypes.bool.isRequired,
  savePreferences: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default HotelSearchPrefsModal;



// WEBPACK FOOTER //
// src/routes/tours/components/HotelSearchPrefsModal.js